var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"mx-0"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('RedirectToApp',{attrs:{"ciUrl":("/apps/business/template/view/" + (_vm.$route.params.id) + "?forceci=true")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }